import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
if (process.env.SENTRY_DSN) {
    const url = process.env.APP_URL;
    Sentry.init({
        Vue: Vue,
        dsn: process.env.SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing({
                tracingOrigins: [url],
            })],
        tracesSampleRate: 1,
        tracingOptions: {
            trackComponents: true,
        },
        logErrors: true,
    });
    window.addEventListener('load', () => {
        if (window.auth.user) {
            Sentry.setUser({ id: window.auth.user.id, email: window.auth.user.email });
        }
    });
}
